import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { twMerge } from "tailwind-merge";

const Button = ({
  children,
  className,
  size = "md",
  variant = "primary",
  isLoading,
  ...rest
}) => {
  const variants = {
    primary:
      "border border-primary-dark bg-primary hover:bg-primary-dark text-white",
    danger:
      "border border-danger-dark bg-danger hover:bg-danger-dark text-white",
    success:
      "border border-success-dark bg-success hover:bg-success-dark text-white",
    outline: "border hover:border-gray-400 text-text-button",
  };

  const sizes = {
    sm: "px-3 text-sm h-9 rounded-lg",
    md: "px-4 text-base h-10 rounded-lg",
    lg: "px-4 text-lg h-12 rounded-lg",
    icon: "text-sm w-8 h-8 rounded-lg",
  };

  return (
    <button
      className={twMerge(
        "inline-flex items-center justify-center gap-2 transition-all duration-300 disabled:opacity-50 disabled:pointer-events-none",
        variants[variant],
        sizes[size],
        className
      )}
      {...rest}
    >
      {isLoading && (
        <AiOutlineLoading3Quarters className="text-lg animate-spin" />
      )}
      {children}
    </button>
  );
};

export default Button;
